import React from 'react';
import styled from 'styled-components';
import { RichText } from '@graphcms/rich-text-react-renderer';

const Wrapper = styled.span`
  font-size: 24px;
  line-height: 29px;
  white-space: pre-wrap;

  a {
    text-decoration: underline;
  }

  p,
  ul,
  ol {
    margin-bottom: 30px;
  }

  p {
    &:last-of-type {
      margin-bottom: ${({ noMarBottom }) => (noMarBottom ? '0' : undefined)};

      @media only screen and (max-width: 810px) {
        margin-bottom: 30px;
      }
    }
  }

  strong {
    //TODO: change font to bolder
    font-weight: bold;
  }

  @media only screen and (max-width: 810px) {
    font-size: 16px;
    line-height: 20px;
  }
`;

const RichTextWrapper = ({ content, firstParMargin, noMarBottom }) => {
  return (
    <Wrapper firstParMargin={firstParMargin} noMarBottom={noMarBottom}>
      <RichText content={content} />
    </Wrapper>
  );
};

export default RichTextWrapper;
